module.exports = __webpack_public_path__ + "img/ic_save_blanc.e3b184e1.svg";